import { Controller } from "@hotwired/stimulus"

// Simple image modal for expanding single images (QR codes, etc.)
// Usage: Add data-controller="image-modal" to wrapper,
//        data-action="click->image-modal#open" to trigger element,
//        data-image-modal-target="modal" to modal container,
//        data-image-modal-url-value="image_url" for full-size image
//        data-image-modal-filename-value="filename" for download filename
export default class extends Controller {
  static targets = ["modal", "image"]
  static values = { url: String, filename: String }

  connect() {
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    // Set the full-size image source
    if (this.hasImageTarget && this.urlValue) {
      this.imageTarget.src = this.urlValue
    }

    this.modalTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    this.modalTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }

  backdropClick(event) {
    // Only close if clicking on the backdrop itself, not the image
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  download(event) {
    event.preventDefault()
    event.stopPropagation()

    if (!this.urlValue) return

    // Fetch the image and trigger download
    fetch(this.urlValue)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = this.filenameValue || 'qr-code.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      })
      .catch(error => {
        console.error('Download failed:', error)
        // Fallback: open in new tab
        window.open(this.urlValue, '_blank')
      })
  }

  handleKeydown = (event) => {
    if (event.key === 'Escape' && this.hasModalTarget && !this.modalTarget.classList.contains('hidden')) {
      this.close()
    }
  }
}
